import { Tab } from 'bootstrap';

window.addEventListener('load', () => {
	let tabs = document.querySelectorAll('.tab-switch');

	if (tabs.length > 0) {
		tabs.forEach((element, i, tabs) => {
			element.addEventListener('click', (e) => {
				tabs.forEach(element => {
					element.classList.remove('active');
					window.location.hash = e.currentTarget.children[0].dataset['bsTarget'];
				});
				e.currentTarget.classList.add('active');
			})
		});

		if (window.location.hash !== '') {
			tabs.forEach((element) => {
				element.classList.remove('active');
				if (window.location.hash === element.children[0].dataset['bsTarget']) {
					const activeTab = new Tab(element.children[0]);
					element.classList.add('active');
					activeTab.show();
				}
			});
		}
	}
})
